import React from "react";
import { useHandleRedirect } from "./Redirect.hooks";
import { Spinner } from "components/Spinner/Spinner";

/**
 * Redirect component that handles URL-based navigation to specific modules
 *
 * Usage: /redirect?module=project&ProjectId=1001&ProgrammeId=1000
 *
 * Validates URL parameters, shows appropriate error messages for invalid links,
 * and redirects to the correct module view.
 */
const Redirect: React.FC = () => {
  const { isRedirecting } = useHandleRedirect();

  // Show spinner while processing redirect
  if (isRedirecting) {
    return <Spinner positionAbsolute />;
  }

  // If we're not redirecting anymore, show nothing (navigation has occurred)
  return null;
};

export default Redirect;
